import { Dropdown } from 'react-bootstrap';
import { faFileExport, faArchive, faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface ActionDropdownItemsProps {
  productId: string;
}

const ActionDropdownItems: React.FC<ActionDropdownItemsProps> = ({ productId }) => {
  const { t } = useTranslation();
  const handleViewClick = (id: string) => {
    const sellerData = JSON.parse(localStorage.getItem('seller') || '{}');
    const sid = sellerData.sid || '';
    window.open(`${process.env.REACT_APP_MAGENTO_URL}marketplace/catalog/view/id/${id}/?SID=${sid}`, '_blank');
  };

  return (
    <>
      <Dropdown.Item onClick={() => handleViewClick(productId)} className="text-secondary">
        <FontAwesomeIcon icon={faEye} className="fs-9 me-2" />
        {t("products.view")}
      </Dropdown.Item>
      <Dropdown.Item 
        as={Link} 
        to={`/products/${productId}`} 
        className="text-secondary"
      >
        <FontAwesomeIcon icon={faEdit} className="fs-9 me-2" />
        {t("products.edit")}
      </Dropdown.Item>
      {/* <Dropdown.Item className="text-secondary">
        <FontAwesomeIcon icon={faFileExport} className="fs-9 me-2" />
        Export
      </Dropdown.Item>
      <Dropdown.Item className="text-secondary">
        <FontAwesomeIcon icon={faArchive} className="fs-9 me-2" />
        Archive
      </Dropdown.Item> */}
    </>
  );
};

export default ActionDropdownItems;
